import Icon from 'veui/components/Icon'

Icon.register({
  'clipboard-checked': {
    paths: [
      {
        d: 'M640 96h-64V64a32 32 0 00-32-32H224a32 32 0 00-32 32v32h-64a32 32 0 00-32 32v576a32 32 0 0032 32h512a32 32 0 0032-32V128a32 32 0 00-32-32zm-384 0h256v64H256zm352 576H160V160h32v32a32 32 0 0032 32h320a32 32 0 0032-32v-32h32zm-69.37-302.25l-128 192a32 32 0 01-23.48 14.09 30.21 30.21 0 01-3.15.16 32 32 0 01-22.63-9.37l-96-96a32 32 0 0145.26-45.26l68.4 68.4 106.34-159.52a32 32 0 0153.26 35.5z'
      }
    ],
    width: '768',
    height: '768'
  }
})
